// extracted by mini-css-extract-plugin
export default {"modalRateContainer":"modalRateContainer__aLqJX","text":"text__k59pz","button":"button__fg4Ds"};